import api from "./axios";

export const getDocuments = () => api.get("/documents");

export const uploadDocument = (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post("/documents/upload", formData, {
    onUploadProgress,
  });
};

export const deleteDocument = (documentPublicId) =>
  api.delete(`/documents/${documentPublicId}`);
